import { CampaignDescriptionText } from "@/components/campaigns/campaign-shell/campaign-sections";
import { useCampaign } from "@/hooks";

/** The tournament's About body: the shared Info-card description, fed from the live campaign. */
export const TournamentDescription = () => {
  const { campaignData } = useCampaign();

  return <CampaignDescriptionText text={campaignData?.campaign_info} />;
};
